import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ArchivedLocation, ArchivedLocationResponse, LocationResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class ArchiveService {
  private http = inject(HttpClient);
  private apiHost = `${environment.apiBaseUrl}/locations/archive`;

  getMyArchivedLocations(forBranchId?: number): Observable<ArchivedLocation[]> {
    const params = new HttpParams().set('branchId', forBranchId);
    return this.http.get<ArchivedLocation[]>(this.apiHost, { params });
  }

  archiveLocation(location_id: number): Observable<ArchivedLocationResponse> {
    return this.http.post<ArchivedLocationResponse>(this.apiHost, {
      location_id,
    });
  }

  unarchiveLocation(location_id: number): Observable<LocationResponse> {
    return this.http.delete<LocationResponse>(`${this.apiHost}/${location_id}`);
  }
}
